import { useTranslation } from "react-i18next"

import {
  FLOW_DIRECTION_VALUE_KEYS,
  type FlowDirectionLabels,
  formatFlowDirection as formatFlowDirectionValue,
} from "./format-flow-direction"

interface UseFormatFlowDirectionValue {
  formatFlowDirection: (value: string | null | undefined) => string
}

export const useFormatFlowDirection = (): UseFormatFlowDirectionValue => {
  const { t } = useTranslation("common")
  const labels: FlowDirectionLabels = {
    export: t(FLOW_DIRECTION_VALUE_KEYS.export),
    import: t(FLOW_DIRECTION_VALUE_KEYS.import),
  }

  return {
    formatFlowDirection: (value) => formatFlowDirectionValue(value, labels),
  }
}
